import React from "react";
import styles from "./vietnam-discovery.module.css";
import PromoSidebar from "../../../PromoSidebar/PromoSidebar";
// import FooterBottom from "../../../../Footer/SocialLinks";
import CTASection from "../../../../CTASection/CTASection";
import BlogNavigator from "../../../BlogNavigator/BlogNavigator.js";
import { travelBlogs } from "../Travelinternational.js";
import FAQSection from '../../../../Contact/FAQSection.js';

import i1 from "./best food.webp";
import i2 from "./best places.webp";
import i3 from "./Culture & Festivals.webp";
import i4 from "./travel tips.webp";
import i5 from "./(8).webp";



export default function VietnamBlog() {
  const sections = [
     {
    id: "places",
    title: "Best Places to Visit in Vietnam",
    image: i2,
    paragraphs: [
      `Vietnam is filled with breathtaking landscapes, ancient towns, 
      limestone mountains, and stunning beaches. From the lantern-lit 
      streets of Hoi An to the emerald waters of Halong Bay, every region 
      offers a unique travel experience. Whether you love adventure, 
      history, or relaxing by the sea, Vietnam has something unforgettable 
      for every traveler.`,

      `Some cities like Hanoi and Ho Chi Minh bring rich culture and 
      nightlife, while places like Da Nang and Ninh Binh offer peaceful 
      nature escapes. If you're planning a well-balanced Vietnam 
      itinerary, these must-visit destinations should be at the top of 
      your list.`,
    ],
    bullets: [
      "Halong Bay: Limestone cliffs, cave cruises & luxury overnight stays.",
      "Hoi An: Ancient town, lantern festival & riverside cafes.",
      "Sapa: Terraced rice fields, trekking & mountain villages.",
      "Da Nang: Beaches, Marble Mountains & Golden Bridge.",
      "Ninh Binh: “Halong Bay on land” with boat rides in Tam Coc.",
    ],
  },

  {
    id: "food",
    title: "Best Vietnamese Food & Street Dishes to Try",
    image: i1,
    paragraphs: [
      `Vietnam is a paradise for food lovers. From sizzling street food to 
      aromatic soups and fresh herbs, Vietnamese cuisine is all about 
      bold, refreshing flavors. Whether you're walking through Hanoi's Old 
      Quarter or exploring the night markets of Ho Chi Minh City, the street 
      food scene is vibrant, affordable, and incredibly delicious.`,

      `Each region has its own special dish—North Vietnam loves simple and 
      hearty flavors, Central Vietnam is known for spices, while the South 
      offers sweet, fresh, tropical tastes. You simply cannot complete your 
      Vietnam trip without trying these iconic foods.`,
    ],
    bullets: [
      "Pho: Vietnam’s most famous noodle soup with rich broth.",
      "Banh Mi: Crispy French bread stuffed with meat & veggies.",
      "Spring Rolls: Fresh or fried rolls packed with herbs & shrimp.",
      "Bun Cha: Charcoal-grilled pork served with noodles.",
      "Egg Coffee: Creamy Hanoi specialty made with whipped egg foam.",
    ],
  },

  {
    id: "culture",
    title: "Vietnam Culture, Festivals & Traditions",
    image: i3,
    paragraphs: [
      `Vietnam’s culture is a beautiful blend of ancient traditions, Buddhist 
      beliefs, and warm hospitality. Locals are deeply connected to family, 
      festivals, and community. Whether you visit a peaceful temple in Hanoi 
      or walk through the colorful streets of Hoi An, you’ll feel the 
      authenticity everywhere.`,

      `The country also celebrates vibrant festivals filled with music, food, 
      dances, and centuries-old rituals. Experiencing even one festival can 
      make your Vietnam trip feel more meaningful and memorable.`,
    ],
    bullets: [
      "Tet Festival: Vietnam’s biggest celebration — Lunar New Year.",
      "Mid-Autumn Festival: Lantern parades & mooncakes.",
      "Ao Dai Tradition: National dress symbolizing grace & elegance.",
      "Water Puppetry: 11th-century art form that fascinates tourists.",
      "Pagoda Culture: Temples are peaceful spaces loved by locals.",
    ],
  },

  {
    id: "tips",
    title: "Vietnam Travel Tips for First-Time Travelers",
    image: i4,
    paragraphs: [
      `Traveling to Vietnam for the first time? A little planning can make 
      your trip smooth, budget-friendly, and unforgettable. From choosing 
      the right season to understanding local transport, these simple tips 
      will help you enjoy Vietnam like a pro traveler.`,

      `Vietnam is safe, affordable, and very tourist-friendly. Still, knowing 
      a few practical details about money, food, weather, and etiquette 
      can make a big difference in your overall travel experience.`,
    ],
    bullets: [
      "Best Time: Feb–April & Aug–Oct for ideal weather.",
      "Currency: Use cash for markets; ATMs widely available.",
      "Transport: Grab, trains, buses, and flights are cheap.",
      "Food Safety: Choose busy street stalls with high turnover.",
      "Communication: English is common in tourist areas.",
    ],
  },
  ];

const vietnamFaqData = [
  {
    question: "What is the best time to visit Vietnam?",
    answer:
      "The ideal time to visit Vietnam is from February to April and August to October when the weather is pleasant and perfect for exploring cities, beaches, and mountains across the country.",
  },
  {
    question: "Is Vietnam safe for tourists?",
    answer:
      "Yes, Vietnam is one of the safest Southeast Asian countries for travelers. Just follow basic precautions like keeping your valuables secure in crowded areas.",
  },
  {
    question: "How many days are enough for a Vietnam trip?",
    answer:
      "A 6–10 day trip covers the major highlights like Hanoi, Halong Bay, Da Nang, Hoi An, and Ho Chi Minh City. For a deeper experience, plan 12–14 days.",
  },
  {
    question: "Do Indians need a visa to visit Vietnam?",
    answer:
      "Yes, Indian passport holders require an e-visa for Vietnam. The process is simple and can be applied online easily before your trip.",
  },
  {
    question: "What is the local currency used in Vietnam?",
    answer:
      "Vietnam uses the Vietnamese Dong (VND). Card payments are widely accepted but keeping some cash is recommended for markets and small shops.",
  },
  {
    question: "Is vegetarian food easily available in Vietnam?",
    answer:
      "Yes! Vietnam offers plenty of vegetarian and vegan options. Cities like Hanoi, Da Nang, and Ho Chi Minh City have many vegetarian restaurants and street-food stalls.",
  },
  {
    question: "What are the must-try Vietnamese dishes?",
    answer:
      "Pho (noodle soup), Banh Mi, Bun Cha, spring rolls, and egg coffee are must-try dishes for every traveler visiting Vietnam.",
  },
  {
    question: "Is Vietnam expensive for Indian tourists?",
    answer:
      "Not at all! Vietnam is budget-friendly with affordable hotels, food, transport, and shopping — an ideal international destination for Indian travelers.",
  },
];


  return (
    <article className={styles.blogContainer}>

      <header className={styles.hero}>
        <img
          src={i5}
          alt="Vietnam landscape"
          className={styles.heroImg}
        />
        <div className={styles.heroOverlay} />
        <div className={styles.heroText}>
          <h1>Vietnam Travel Guide 2025: Best Places, Food, Culture & Tips</h1>
          <p>Plan your Vietnam trip with important travel tips, must-visit places & itinerary ideas.</p>
        </div>
      </header>

      <section className={styles.factsSection}>
        <h2 className={styles.sectionHeading}>Quick Facts About Vietnam</h2>

        <div className={styles.factsGrid}>
          <div className={styles.factCard}>
  <h4>Best Time to Visit Vietnam</h4>
  <p>
    February to April and August to October — pleasant weather, clear skies,
    and ideal for exploring North, Central & South Vietnam.
  </p>
</div>

<div className={styles.factCard}>
  <h4>Currency in Vietnam (VND)</h4>
  <p>
    Vietnam uses the Vietnamese Dong (VND). Cash is preferred in markets;
    cards are accepted in cities and hotels.
  </p>
</div>

<div className={styles.factCard}>
  <h4>Languages Spoken in Vietnam</h4>
  <p>
    Vietnamese is the official language. English is widely understood in
    major tourist areas like Hanoi, Da Nang & Ho Chi Minh City.
  </p>
</div>

<div className={styles.factCard}>
  <h4>Ideal Vietnam Trip Duration</h4>
  <p>
    6–10 days for major highlights (Hanoi, Halong Bay, Da Nang, Hoi An,
    Ho Chi Minh City). 12+ days if you want a full Vietnam experience.
  </p>
</div>

        </div>
      </section>

  

      <main className={styles.article}>

        <aside className={styles.sidebar}>
          <h3>On This Page</h3>
          <ul>
            {sections.map((sec) => (
              <li key={sec.id}>
                <a href={`#${sec.id}`}>{sec.title}</a>
              </li>
            ))}
          </ul>
        </aside>

        <div className={styles.content}>
          {sections.map((sec) => (
  <section id={sec.id} key={sec.id} className={styles.contentBlock}>
    
    <h2>{sec.title}</h2>

    {sec.paragraphs.map((para, i) => (
      <p key={i}>{para}</p>
    ))}

    <img
      src={sec.image}
      alt={sec.title}
      className={styles.contentImg}
    />

    <ul className={styles.bulletList}>
      {sec.bullets.map((bullet, i) => (
        <li key={i}>{bullet}</li>
      ))}
    </ul>
 <hr/>
  </section>
))}

        </div>
      </main>
 <CTASection
  heading="Ready to Explore the Beauty of Vietnam?"
  description="From Hanoi’s culture to Da Nang’s beaches and the lantern-lit streets of Hoi An—Vietnam is the perfect blend of nature, history, and adventure. Let’s plan your unforgettable trip."
  buttonText="Plan Your Vietnam Trip"
  buttonLink="tel:+919876543210"
/>

   
<section className={styles.faqWrapper}>
<div className={styles.faqSection}>
 
  <FAQSection data={vietnamFaqData} />

</div>



  <aside className={styles.tipsSidebar}>
    <PromoSidebar
  offers={[
    {
      id: 1,
      title: "🔥 Vietnam Travel Mega Deal",
      desc: "Enjoy up to 30% OFF on Vietnam holiday packages — Hanoi, Da Nang, Hoi An & Ho Chi Minh included!",
      btn: "Book Vietnam Trip",
      images: [i5],
    },
  ]}
/>


  </aside>

</section>
    
      <BlogNavigator
            category="Travelinternational"
            blogs={travelBlogs}
            currentBlogId="vietnam-discovery"
          />
    </article>
     
  );
}
